import { createApp, h, onBeforeMount, provide, reactive } from "vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import App from "./App.vue";
import Clipboard from 'v-clipboard'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons'

// create vue instance
const app = createApp({
  setup() {
    // define global data
    const $device = reactive({
      isMobile: window.matchMedia("(max-width: 633px)").matches,
      vpWidth: window.innerWidth,
      vpHeight: window.innerHeight,
    });

    onBeforeMount(() => {
      window.addEventListener("resize", () => {
        Object.assign($device, {
          isMobile: window.matchMedia("(max-width: 633px)").matches,
          vpWidth: window.innerWidth,
          vpHeight: window.innerHeight,
        });
      });
    });

    provide("$device", $device);

    return {};
  },
  devtools: {
    hide: import.meta.env.PROD,
  },
  render: () => h(App),
});

// register Vuetify
app.component('font-awesome-icon', FontAwesomeIcon) // Register component globally
library.add(fas) // Include needed solid icons
library.add(far) // Include needed regular icons
library.add(fab) // Include needed brand icons

app.use(vuetify());

// register Routes
app.use(router);
app.use(Clipboard);

// mount app in index.html
app.mount("#app");
